(function($) {
	$(document).ready(function() {
		var $win = $(window),
			$body = $('body'),
			$main = $('.main');

		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
			$(this).wrap("<div class='responsive-embed'/>");
			}
		});

		// if( $win.width() > 480) {

		// }
		$('#ae-cform-input-reg-email-1').attr('placeholder', 'Email');

		$('.top-bar .menu-bars').on('click', function() {
			$(this).find('.fas').toggleClass('fa-times');
		});
		$('.js-off-canvas-overlay').on('click', function() {
			$('.top-bar .menu-bars .fas').removeClass('fa-times');
		});

		if( $body.hasClass('home') ) {
			var $banner = $('.js-banner'),
				$videos = $('.js-video-list'),
				$releases = $('.js-release-list'),
				$menu = $('#main-nav li a');

			$('.js-subscribe a').on('click', function(e) {
				e.preventDefault();

				var $target = $(this).attr('href');

				$('html, body').animate({
					scrollTop: $($target).offset().top
				}, 800);

				if ( $(this).parents('.off-canvas') ) {
					$('.js-off-canvas-overlay').trigger('click');
				}
			});
			
			$banner.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				responsive: [
					{
					breakpoint: 815,
					settings: {
						arrows: false
					}
					}
				]
			});

			$('.section-banner').addClass('init');

			$banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				$banner.addClass('is-sliding');
			});
		
			$banner.on('afterChange', function(event, slick, currentSlide){
				$banner.removeClass('is-sliding');
			});

			$releases.on('init', function(event, slick){
				var currentSlide = $(this).find('.slick-slide.slick-current');

				if(currentSlide) {
					// textAnime();
				}
			});

			$releases.slick({
				asNavFor: '.album-cover-list'
			});

			$('.album-cover-list').slick({
				arrows: false,
				dots: false,
				fade: true,
				cssEase: 'linear',
				asNavFor: '.js-release-list',
				focusOnSelect: true
			});

			$releases.on('afterChange', function(event, slick, currentSlide){
				$releases.addClass('slided');
			});

			$videos.on('init', function(event, slick){
				var currentSlide = $(this).find('.slick-slide.slick-current');

				if(currentSlide) {
				
				}
			});

			$videos.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
			});
		
			$videos.on('afterChange', function(event, slick, currentSlide){
				$videos.addClass('slided');
			});

			$('.article-video .button').on('click', function(e) {
				e.preventDefault();
		
				var youtubeID = $(this).data('id'),
					embedCode = "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" + youtubeID + "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
					$parent = $(this).parents('.type-video');
					
				if (!document.querySelector('.media-youtube-video')) {
					$parent.addClass('playing');
					$parent.append(embedCode);
					$('.js-video-list').addClass('has-embed');
				} else {
					$parent.removeClass('playing');
					$('.media-youtube-video').remove();
					$('.js-video-list').removeClass('has-embed');
				}
			});
			$('.js-video-list > button').on('click', function(){
				if ($('.article-video').hasClass('playing')) {
					$('.media-youtube-video').remove();
					$('.article-video').removeClass('playing');
					$('.js-video-list').removeClass('has-embed');
				}
			});

			$('.js-intro-arrow').on('click', function(e){
				e.preventDefault();

				$('html, body').animate({
					scrollTop: $('.section-about').offset().top - 64
				}, 500);
			});

			$('.main-home .section').each(function(){
				var self = $(this);
			
				$(this).waypoint({
					handler: function(direction) {

						if( self.hasClass('section-music') ) {
						}

						if( self.hasClass('section-videos') ) {
						}

						// if(direction == 'down') {
						// }

						// $('.main-home .section').removeClass('show');
						self.addClass('show');
					}, offset: '50%'
				});
			});

			if( $win.width() < 480) {

				var waypoints = $('.section-about').waypoint({
					handler: function(direction) {
						if(direction == 'up') {
						$('#top-bar-menu .logo').removeClass('show');
						} else {
						$('#top-bar-menu .logo').addClass('show');
						}
					}, offset: '0'
					});
			}
		} else { // page home

			$('.js-subscribe a').fancybox({
				padding: 0
			});
		}

		if( $body.hasClass('home') || $main.hasClass('main-news') || $body.hasClass('single') ) {
			var ppp = 6; // Post per page
			var pageNumber = 1;

			function load_posts(){
				pageNumber++;
				var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax';
				$.ajax({
					type: "POST",
					dataType: "html",
					url: ajax_posts.ajaxurl,
					data: str,
					success: function(data){
						var $data = $(data);
						if($data.length){
							$("#news-list").append($data);
							$("#more_posts").attr("disabled",false);
						} else{
							$("#more_posts").attr("disabled",true);
						}
					},
					error : function(jqXHR, textStatus, errorThrown) {
						$('.section-news .section-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
					}

				});
				return false;
			}

			$("#more_posts").on("click",function(e){ // When btn is pressed.
				e.preventDefault();

				$("#more_posts").attr("disabled",true); // Disable the button, temp.
				load_posts();

				if( $body.hasClass('single') ) {
					setTimeout(function(){
						$('html, body').animate({
							scrollTop: $('main .backpage').offset().top
						}, 800);
						$('#news-list').animate({
							scrollTop: $('#news-list').get(0).scrollHeight
						}, 500);
					}, 600);
				}

				// $(this).insertAfter('#news-list'); // Move the 'Load More' button to the end of the the newly added posts.
			});
		}

		if( $main.hasClass('main-music') ) {
			var $banner = $('.js-banner');
			
			$banner.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				responsive: [
					{
					breakpoint: 815,
					settings: {
						arrows: false
					}
					}
				]
			});

			$('.section-banner').addClass('init');
		}

		if( $body.hasClass('single-release') ) {
			var ppp = 12; // Post per page
			var pageNumber = 1;

			function load_posts(){
				pageNumber++;
				var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_release_ajax';
				$.ajax({
					type: "POST",
					dataType: "html",
					url: ajax_posts.ajaxurl,
					data: str,
					success: function(data){
						var $data = $(data);
						if($data.length){
							$("#music-list").append($data);
							$("#more_releases").attr("disabled",false);
						} else{
							$("#more_releases").attr("disabled",true);
						}
					},
					error : function(jqXHR, textStatus, errorThrown) {
						$('.latest .section-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
					}

				});
				return false;
			}

			$("#more_releases").on("click",function(e){ // When btn is pressed.
				e.preventDefault();

				$("#more_releases").attr("disabled",true); // Disable the button, temp.
				load_posts();
			});
		} // single-release
		
	});
})(jQuery);